import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../redux/root-reducer';

const selectActiveStep = createSelector(
  (state: RootState) => state.steps,
  steps => steps.activeStep,
);

export { selectActiveStep };
